import ConfigManager from '@/config/ConfigManager';
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import Util from "@/helper/Utility.js";
export default {
    apiGetThemeContent: function(app_id) {
        const url = ConfigManager.getBlobUrl()  + `/webconfig/announcement_landing/${app_id}/announcementtheme.json`;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    },
    apiGetDashboardAnnouncement: function (params, weblandingBlob) {
        let url = '';
        url = Util.getApiUrlFromWeblandingBlob(weblandingBlob, "dashboard");
        url = url.replace("{config}", `${params.appId}/winners?round=${params.round}`)
        return BzbsApi.connectBzbsGetWithAppId(url, null, null, params.appId).pipe(map((res) => {
            return res.data
        }));
    },
}

